import { fields as userFields } from "@/lib/user/fields";

const { app_language_code } = userFields;

export const languageFields = {
  app_language_code,
};
